import React from 'react';
import { Pill } from './Pill';
interface SectionHeadingProps {
  eyebrow?: string;
  eyebrowTone?: 'terracotta' | 'gold' | 'indigo' | 'ivory';
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: 'center' | 'left';
  tone?: 'dark' | 'light';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  eyebrowTone = 'terracotta',
  title,
  lead,
  align = 'center',
  tone = 'dark',
  className = ''
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl';
  const titleColor = tone === 'dark' ? 'text-ink' : 'text-ivory';
  const leadColor = tone === 'dark' ? 'text-stone' : 'text-ivory/70';
  return <div className={`${alignment} ${className}`} data-id="element-182" data-mp="6tn9lyps97kx">
      {eyebrow ? <Pill tone={eyebrowTone} data-id="element-183" data-mp="6s2by08698iu">{eyebrow}</Pill> : null}
      <h2 className={`font-display text-[2rem] leading-[1.12] sm:text-4xl lg:text-[2.75rem] ${titleColor} ${eyebrow ? 'mt-4' : ''}`} data-id="element-184" data-mp="uipo4xp4ekb7">
        {title}
      </h2>
      {lead ? <p className={`mt-4 font-sans text-base leading-relaxed ${leadColor} ${align === 'center' ? 'mx-auto max-w-readable' : 'max-w-readable'}`} data-id="element-185" data-mp="zbsnjmgkwnzb">
          {lead}
        </p> : null}
    </div>;
}